import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ResizeService {

    windowResize = new Subject();

    constructor() {}

    windowResized() {
        this.windowResize.next({ width:  window.innerWidth, height:  window.innerHeight });
    }
}
